import api from '../../../services/Api';
import { IAuditoriaCorrelacaoFiscalResultado } from '../interfaces/IAuditoriaCorrelacaoFiscal';

interface BuscarParams {
  empresaId: number;
  periodo: string | undefined;
}

export const AuditoriaCorrelacaoFiscalService = {
  buscarResultado: async (params: BuscarParams): Promise<IAuditoriaCorrelacaoFiscalResultado> => {
    const response = await api.get<IAuditoriaCorrelacaoFiscalResultado>(
      'auditoria-correlacao-fiscal/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
